import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';

export interface UserInvitationDetails {
  invitationID: number;
  invitationToken: string;
  userID: number;
  companyID: number;
  roleID: number;
  expiresOn: string;
  acceptedOn?: string | null;
  completedOn?: string | null;
  emailID: string;
  username: string;
  companyName: string;
  roleName: string;
  invitationStatus: string;
}

@Injectable({
  providedIn: 'root',
})
export class InvitationService {
  private readonly baseUrl = `${normalizeApiBaseUrl(environment.ASquareAPIURL)}Invitation`;

  constructor(private http: HttpClient) {}

  getInvitation(token: string): Observable<UserInvitationDetails> {
    return this.http.get<UserInvitationDetails>(`${this.baseUrl}/${token}`, JSON_HTTP_OPTIONS);
  }

  acceptInvitation(token: string): Observable<{ success: number }> {
    return this.http.post<{ success: number }>(`${this.baseUrl}/${token}/accept`, {}, JSON_HTTP_OPTIONS);
  }

  completeInvitation(token: string, password: string, confirmPassword: string): Observable<{ success: number }> {
    return this.http.post<{ success: number }>(
      `${this.baseUrl}/${token}/complete`,
      { password, confirmPassword },
      JSON_HTTP_OPTIONS
    );
  }
}
